module.exports = __webpack_public_path__ + "img/dentons-logo.7003c5ad.svg";